var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"ag-nomal-action-menu",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.deleteMetro}},[_c('i',{staticClass:"material-icons-outlined align-middle"},[_vm._v("delete")])])])}
var staticRenderFns = []

export { render, staticRenderFns }